<script>
    export let options

    let today = new Date()
    let time = today.getHours() + ':' + today.getMinutes()
</script>

<style lang="scss">div {
  width: 325px;
  border-radius: 10px;
  overflow: hidden;
}
div header {
  padding: 25px 20px;
  overflow: hidden;
  display: flex;
  align-items: center;
  background: #fff;
}
div header figure {
  position: relative;
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-radius: 50px;
  float: left;
  margin-right: 15px;
}
div header figure img {
  width: 100%;
  height: 100%;
  border-radius: 50px;
  object-fit: cover;
  object-position: center;
}
div header figure::before {
  content: "";
  bottom: 0px;
  right: 0px;
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  background-color: #4ad504;
  display: block;
  position: absolute;
  z-index: 1;
  border-radius: 50%;
  border: 2px solid white;
}
div header aside {
  width: calc(100% - 65px);
  float: left;
  margin: 0;
  padding: 0;
}
div header aside h4 {
  float: left;
  margin: 0px;
  padding: 0px;
  letter-spacing: 0.1px;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  color: #111;
  width: 100%;
}
div header aside span {
  float: left;
  color: #333;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  margin-top: 5px;
}
div article {
  padding: 25px 20px;
  background-color: #e6ddd4;
  position: relative;
  overflow: auto;
}
div article::before {
  display: block;
  position: absolute;
  content: "";
  left: 0px;
  top: 0px;
  height: 100%;
  width: 100%;
  z-index: 0;
  opacity: 0.08;
  background-image: url(https://elfsight.com/assets/chats/patterns/whatsapp.png);
}
div article aside {
  padding: 7px 14px 6px;
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.13) 0px 1px 0.5px;
  border-radius: 0px 8px 8px;
  max-width: 225px;
  float: left;
  position: relative;
}
div article aside::before {
  position: absolute;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAmCAMAAADp2asXAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAACQUExURUxpccPDw9ra2m9vbwAAAAAAADExMf///wAAABoaGk9PT7q6uqurqwsLCycnJz4+PtDQ0JycnIyMjPf3915eXvz8/E9PT/39/RMTE4CAgAAAAJqamv////////r6+u/v7yUlJeXl5f///5ycnOXl5XNzc/Hx8f///xUVFf///+zs7P///+bm5gAAAM7Ozv///2fVensAAAAvdFJOUwCow1cBCCnqAhNAnY0WIDW2f2/hSeo99g1lBYT87vDXG8/6d8oL4sgM5szrkgl660OiZwAAAHRJREFUKM/ty7cSggAABNFVUQFzwizmjPz/39k4YuFWtm55bw7eHR6ny63+alnswT3/rIDzUSC7CrAziPYCJCsB+gbVkgDtVIDh+DsE9OTBpCtAbSBAZSEQNgWIygJ0RgJMDWYNAdYbAeKtAHODlkHIv997AkLqIVOXVU84AAAAAElFTkSuQmCC);
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: contain;
  content: "";
  top: 0px;
  left: -12px;
  width: 12px;
  height: 19px;
}
div article aside span {
  color: #999;
  font-size: 13px;
  margin-bottom: 10px;
  float: left;
  width: 100%;
  font-weight: 500;
}
div article aside p {
  font-size: 14px;
  line-height: 19px;
  margin: 0;
  color: #000000;
  float: left;
  width: 100%;
}
div article aside small {
  font-size: 12px;
  line-height: 16px;
  color: #999;
  width: 100%;
  text-align: right;
  padding-top: 0px;
  float: right;
  margin-right: -4px;
  margin-bottom: 0px;
}
div footer {
  padding: 20px;
  overflow: hidden;
  background: #fff;
  display: block;
}
div footer a {
  text-decoration: none;
  font-size: 15px;
  color: #fff;
  background: #4fce5d;
  padding: 8px 14px;
  width: 100%;
  float: left;
  text-align: center;
  font-weight: bold;
  border-radius: 50px;
}
/*# sourceMappingURL=src/components/Integrations/WhatsApp.svelte.map */</style>

<div>
    <header>
        <figure>
            <img src={options.avatar} alt={options.user_name} />
        </figure>

        <aside>
            <h4>{options.user_name}</h4>
            <span>{options.caption}</span>
        </aside>
    </header>

    <article>
        <aside>
            <span>{options.user_name}</span>
            <p>{@html options.welcome_message}</p>
            <small>{time}</small>
        </aside>
    </article>

    <footer>
        <a
            href="https://api.whatsapp.com/send?phone={options.phone}"
            target="_blank"
            style="background-color:{options.color};">Start Chat</a
        >
    </footer>
</div>